module.exports = __webpack_public_path__ + "static/media/VNI.e1cfb741.png";